module.exports = __webpack_public_path__ + "img/27.6b8c1211.png";